import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { setopen_modal } from '../../slices/globalslice';
//import images
// import avatar1 from "../../assets/images/users/avatar-1.jpg";
import circleavatar from "../../assets/images/users/circleavatar.jpeg";
import useAuth from '../../hooks/useAuth';
import { toggleLayoutAction } from '../../slices/layouts/reducer';
import { useDispatch,useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label } from "reactstrap";
const ProfileDropdown = () => {
const {logout, deleteAccount, changeEmail : changeEmailMutation} = useAuth()
const dispatch = useDispatch()
    const profile_Details = useSelector(state => state.globalslice.profile_Details);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [emailForm, setEmailForm] = useState({
    oldEmail: "",
    newEmail: "",
    confirmEmail: "",
  });

const changeEmail = changeEmailMutation();

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const handleToggleLayout = () =>{
        dispatch(toggleLayoutAction(true))    
    }

       function tog_center() {
        dispatch(setopen_modal(true))
    }

    const handleDeleteAccount = () => {
        setShowDeleteModal(true);
    };

    const confirmDeleteAccount = () => {
        setShowDeleteModal(false);
        deleteAccount.mutate(); // 🔥 temp delete logic
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const openSettingsModal = () => {
        setShowSettingsModal(true);
    };

    const closeSettingsModal = () => {
        setShowSettingsModal(false);
    };

    const handleEmailChange = (e) => {
        const { name, value } = e.target;

        setEmailForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // const changeEmail = {
    //     mutate: (payload) => {
    //         console.log(payload, "changeEmail payload");
    //     }
    // };

    const handleChangeEmail = () => {
        if (emailForm.newEmail !== emailForm.confirmEmail) {
            alert("New email and confirm email do not match");
            return;
        }

        const payload = {
            oldEmail: emailForm.oldEmail,
            newEmail: emailForm.newEmail,
            confirmEmail: emailForm.confirmEmail,
        };

        changeEmail.mutate(payload);
    };

    // const handleDeleteAccount = () => {
    //     const confirmDelete = window.confirm(
    //         "Are you sure you want to delete your account? This action cannot be undone."
    //     );

    //     if (confirmDelete) {
    //         // 🔥 TEMP: using logout API
    //         logout();
    //     }
    // };

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={circleavatar}
                            alt="Header Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{profile_Details?.name}</span>
                            {/* <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">Founder</span> */}
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {profile_Details?.name}!</h6>

                     <DropdownItem className='p-0'>
                        <div className="dropdown-item" onClick={tog_center}>
                            <i
                                className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Change passowrd</span>
                        </div>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <div className="dropdown-item" onClick={handleToggleLayout}>
                            <i
                                className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Layout</span>
                        </div>
                    </DropdownItem>


                    <DropdownItem className='p-0' onClick={(e) => {
                        e.preventDefault()
                        logout()
                    }}>
                        <div className="dropdown-item" >
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Logout</span>
                        </div>
                    </DropdownItem>
                     {/* <DropdownItem className='p-0'>
                        <div
                            className="dropdown-item text-danger"
                            onClick={handleDeleteAccount}
                        >
                            <i className="mdi mdi-delete text-danger fs-16 align-middle me-1"></i>
                            <span className="align-middle">Delete Account</span>
                        </div>
                    </DropdownItem> */}
                    <DropdownItem className='p-0'>
                        <div
                            className="dropdown-item"
                            onClick={openSettingsModal}
                        >
                            <i className="mdi mdi-cog fs-16 align-middle me-1"></i>
                            <span className="align-middle">Settings</span>
                        </div>
                    </DropdownItem>
                    {/* <DropdownItem className='p-0'>
                        <div
                            className="dropdown-item text-danger"
                            onClick={handleDeleteAccount}
                        >
                            <i className="mdi mdi-delete text-danger fs-16 align-middle me-1"></i>
                            <span className="align-middle">Delete Account</span>
                        </div>
                    </DropdownItem> */}
                </DropdownMenu>
            </Dropdown>
            <Modal isOpen={showSettingsModal} toggle={closeSettingsModal} centered>
                <ModalHeader toggle={closeSettingsModal}>
                    Settings
                </ModalHeader>

                <ModalBody>
                    <h6 className="mb-3">Change Email</h6>

                    <div className="mb-3">
                        <Label>Old Email</Label>
                        <Input
                            type="email"
                            name="oldEmail"
                            placeholder="Enter old email"
                            value={emailForm.oldEmail}
                            onChange={handleEmailChange}
                        />
                    </div>

                    <div className="mb-3">
                        <Label>New Email</Label>
                        <Input
                            type="email"
                            name="newEmail"
                            placeholder="Enter new email"
                            value={emailForm.newEmail}
                            onChange={handleEmailChange}
                        />
                    </div>

                    <div className="mb-3">
                        <Label>Confirm New Email</Label>
                        <Input
                            type="email"
                            name="confirmEmail"
                            placeholder="Confirm new email"
                            value={emailForm.confirmEmail}
                            onChange={handleEmailChange}
                        />
                    </div>

                    <div className="d-flex justify-content-end mb-4">
                        <Button
                            color="primary"
                            onClick={handleChangeEmail}
                        >
                            Submit
                        </Button>
                    </div>

                    <hr />

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h6 className="text-danger mb-1">Delete Account</h6>
                            <small className="text-muted">
                                This action cannot be undone
                            </small>
                        </div>

                        <Button
                            color="danger"
                            onClick={() => {
                                closeSettingsModal();
                                handleDeleteAccount();
                            }}
                        >
                            Delete Account
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={showDeleteModal} toggle={closeDeleteModal} centered>
                <ModalHeader toggle={closeDeleteModal}>
                    Confirm Delete
                </ModalHeader>

                <ModalBody>
                    Are you sure you want to delete your account? This action cannot be undone.
                </ModalBody>

                <ModalFooter>
                    <Button color="secondary" onClick={closeDeleteModal}>
                        Cancel
                    </Button>
                    <Button color="danger" onClick={confirmDeleteAccount}>
                        Delete
                    </Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
};

export default ProfileDropdown;
